var React = require('react');

function Support (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.69921 13.8373L5.03382 9.15066L5.17847 9.00601C8.82365 8.86136 10.2412 7.90667 10.2412 6.37338V6.31552C10.2412 5.01366 9.2576 4.26149 7.57966 4.26149C5.95958 4.26149 4.57094 4.92688 3.24016 6.25766L0.5786 3.33573C2.25654 1.48421 4.51308 0.211285 7.66645 0.211285C11.8324 0.211285 14.6675 2.3521 14.6675 6.1998V6.25766C14.6675 9.93177 12.1217 11.4361 8.9683 12.0726L8.65007 13.8373H5.69921ZM4.74452 20.7227V16.0939H9.43118V20.7227H4.74452Z","fill":"currentColor"}));
}

Support.defaultProps = {"width":"15","height":"21","viewBox":"0 0 15 21","fill":"none"};

module.exports = Support;

Support.default = Support;
